import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  connect() {
    this.onScroll = this.onScroll.bind(this);
    document.addEventListener('scroll', this.onScroll);
  }

  disconnect() {
    document.removeEventListener('scroll', this.onScroll);
  }

  onScroll() {
    const pointToShowModal = document.documentElement.scrollHeight;
    const currentScroll = window.scrollY + window.innerHeight;

    if (currentScroll >= pointToShowModal) {
      Turbo.visit("/invite", { frame: "modal" });
      document.removeEventListener('scroll', this.onScroll);
    }
  }
}
